import { render, staticRenderFns } from "./DecorationData.vue?vue&type=template&id=1d05175e&scoped=true"
import script from "./DecorationData.vue?vue&type=script&lang=js"
export * from "./DecorationData.vue?vue&type=script&lang=js"
import style0 from "./DecorationData.vue?vue&type=style&index=0&id=1d05175e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d05175e",
  null
  
)

export default component.exports